import { v7 as uuidv7 } from 'uuid';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { RenewalStatusValues } from '../api/renewal.constants';
import type { RenewalEntryPointValue } from '../constants/renewal-entry-point.constants';

interface RenewalIntentFlowState {
  flowId: string | null;
  entryPoint: RenewalEntryPointValue | null;
  renewalStatusAtEntry: RenewalStatusValues | null;
  startFlow: (params?: {
    entryPoint?: RenewalEntryPointValue;
    renewalStatusAtEntry?: RenewalStatusValues;
  }) => void;
  resetFlow: () => void;
}

export const useRenewalIntentFlowStore = create<RenewalIntentFlowState>()(
  devtools(
    () => ({
      flowId: null as string | null,
      entryPoint: null as RenewalEntryPointValue | null,
      renewalStatusAtEntry: null as RenewalStatusValues | null,
      startFlow: (params) => {
        useRenewalIntentFlowStore.setState((state) => {
          if (state.flowId) {
            return state;
          }
          return {
            flowId: uuidv7(),
            entryPoint: params?.entryPoint ?? null,
            renewalStatusAtEntry: params?.renewalStatusAtEntry ?? null,
          };
        });
      },
      resetFlow: () => {
        useRenewalIntentFlowStore.setState({
          flowId: null,
          entryPoint: null,
          renewalStatusAtEntry: null,
        });
      },
    }),
    { name: 'renewal-intent-flow-store' },
  ),
);
